import React, {useMemo, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Loading} from '../../../../../components/Loadings/loading'
import styles from '../../modalClient.module.css'

type Props = {
  plants: any[]
  formik: any
  loading?: boolean
}

type Filter = 'all' | 'linked'

const PLANT_ICON = toAbsoluteUrl('/media/imgs/plant2.png')

const ListPlantsLinked: React.FC<Props> = ({plants, formik, loading}) => {
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState<Filter>('all')

  const selectedIds: string[] = formik.values.idsPlants || []

  const filteredPlants = useMemo(() => {
    const term = search.trim().toLowerCase()
    return plants.filter((plant) => {
      if (filter === 'linked' && !selectedIds.includes(plant.id)) return false
      if (!term) return true
      return (
        (plant.name || '').toLowerCase().includes(term) ||
        (plant.address || '').toLowerCase().includes(term)
      )
    })
  }, [plants, search, filter, selectedIds])

  const togglePlant = (plantId: string) => {
    const next = selectedIds.includes(plantId)
      ? selectedIds.filter((id) => id !== plantId)
      : [...selectedIds, plantId]
    formik.setFieldValue('idsPlants', next)
  }

  const emptyMessage = search
    ? 'Nenhuma usina encontrada para essa busca.'
    : filter === 'linked'
    ? 'Nenhuma usina vinculada a este cliente.'
    : 'Não há usinas disponíveis para esta filial.'

  return (
    <>
      <div className={styles.plantsToolbar}>
        <div className={`input-group input-group-solid ${styles.iconGroup} ${styles.search}`}>
          <span className='input-group-text'>
            <i className='bi bi-search fs-6 text-reset'></i>
          </span>
          <input
            type='search'
            className='form-control form-control-solid'
            placeholder='Buscar por nome ou endereço'
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </div>

        <div className={styles.segmented} role='radiogroup' aria-label='Filtrar usinas'>
          <button
            type='button'
            role='radio'
            aria-checked={filter === 'all'}
            className={`${styles.segment} ${filter === 'all' ? styles.segmentActive : ''}`}
            onClick={() => setFilter('all')}
          >
            Todas
          </button>
          <button
            type='button'
            role='radio'
            aria-checked={filter === 'linked'}
            className={`${styles.segment} ${filter === 'linked' ? styles.segmentActive : ''}`}
            onClick={() => setFilter('linked')}
          >
            Vinculadas
          </button>
        </div>
      </div>

      <div className={styles.plantList} aria-label='Usinas'>
        {loading ? (
          <div className={styles.emptyBox}>
            <Loading myClass='spinner-border' style={{width: '2rem', height: '2rem'}} />
          </div>
        ) : filteredPlants.length > 0 ? (
          filteredPlants.map((plant: any) => {
            const selected = selectedIds.includes(plant.id)
            return (
              <button
                key={plant.id}
                type='button'
                role='checkbox'
                aria-checked={selected}
                className={`${styles.plantItem} ${selected ? styles.plantItemSelected : ''}`}
                onClick={() => togglePlant(plant.id)}
              >
                <img src={PLANT_ICON} alt='' className={styles.plantItemIcon} />
                <span className={styles.plantItemText}>
                  <span className={styles.plantItemName} title={plant.name}>
                    {plant.name}
                  </span>
                  <span className={styles.plantItemAddress}>
                    {plant.address ? plant.address : 'Endereço não localizado'}
                  </span>
                </span>
                <span className={`${styles.checkbox} ${selected ? styles.checkboxChecked : ''}`}>
                  {selected && <i className='bi bi-check-lg text-white'></i>}
                </span>
              </button>
            )
          })
        ) : (
          <div className={styles.emptyBox}>
            <KTSVG
              path='/media/icons/duotune/general/gen004.svg'
              className='svg-icon-2x svg-icon-muted'
            />
            {emptyMessage}
          </div>
        )}
      </div>
    </>
  )
}

export {ListPlantsLinked}
